"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _config = _interopRequireDefault(require("@dom/config"));

var _data = require("./data");

require("./css/footer.scss");

var basicClassName = 'indicator indicator--small';
var classNameWithHover = "".concat(basicClassName, " hover");
var footerStyle = {
  // position: '-webkit-sticky',
  position: 'sticky',
  bottom: '0',
  height: '0px',
  padding: '5px 0',
  zIndex: '-1'
};

var FooterIndicator = function FooterIndicator(_ref) {
  var highLight = _ref.highLight,
      quoteNumber = _ref.quoteNumber;
  return _react["default"].createElement("div", {
    className: highLight ? 'd-lg-none' : 'd-none d-lg-block'
  }, _react["default"].createElement("div", {
    className: "indicators"
  }, _data.footerQuotes.map(function (list, i) {
    return _react["default"].createElement("div", {
      key: list.author,
      className: highLight ? quoteNumber === i ? classNameWithHover : basicClassName : "indicator indicator--".concat(i + 1, " indicator--right")
    }, _react["default"].createElement("div", {
      className: "indicator-content"
    }, "\u2018", list.quote_1, _react["default"].createElement("br", null), list.quote_2, ".\u2019", _react["default"].createElement("br", null), _react["default"].createElement("small", null, "- ", list.author)));
  })));
};

var Footer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Footer, _Component);

  function Footer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Footer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Footer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      quoteNumber: 0
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "changeQuote", function () {
      var currentQuote = _this.state.quoteNumber;
      var nextQuote = currentQuote > 1 ? 0 : currentQuote + 1;

      _this.setState({
        quoteNumber: nextQuote
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(Footer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      setInterval(this.changeQuote, 5000);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.changeQuote);
    }
  }, {
    key: "render",
    value: function render() {
      var quoteNumber = this.state.quoteNumber;
      return _react["default"].createElement("div", {
        className: "footerAll",
        style: footerStyle
      }, _react["default"].createElement("section", {
        className: "section section--white teaser py-5"
      }, _react["default"].createElement("div", {
        className: "container"
      }, _react["default"].createElement("h2", {
        className: "text-uppercase text-center section-header"
      }, "We are featured by"), _react["default"].createElement("div", {
        className: "row mt-4"
      }, _data.featuredByList.map(function (v) {
        return _react["default"].createElement("div", {
          key: v.href,
          className: "col-6 col-sm-4 col-md mt-3 mt-md-0"
        }, _react["default"].createElement("a", {
          href: v.href,
          target: "_blank",
          rel: "noopener noreferrer nofollow"
        }, _react["default"].createElement("img", {
          src: v.imgSrc,
          alt: "LP"
        })));
      })))), _react["default"].createElement("section", {
        id: "teaser",
        className: "section section--white teaser"
      }, _react["default"].createElement("img", {
        src: "".concat(_config["default"].ASSETS_URL, "/everest_kalapathar.jpg"),
        alt: "mountain teaser",
        className: "background-mountains"
      }), _react["default"].createElement("img", {
        src: "".concat(_config["default"].ASSETS_URL, "/tree.png"),
        alt: "trees",
        className: "overlay-trees"
      }), _react["default"].createElement(FooterIndicator, {
        highLight: false
      }), _react["default"].createElement(FooterIndicator, {
        highLight: true,
        quoteNumber: quoteNumber
      })), _react["default"].createElement("footer", {
        className: "footer"
      }, _react["default"].createElement("div", {
        className: "footer-background"
      }, _react["default"].createElement("div", {
        className: "container"
      }, _react["default"].createElement("div", {
        className: "row mb-5 pb-5"
      }, _react["default"].createElement("div", {
        className: "col-md-6 col-lg-2"
      }), _react["default"].createElement("div", {
        className: "col-md-6 col-lg-3"
      }, _react["default"].createElement("h5", {
        className: "mb-3"
      }, "Company"), _react["default"].createElement("ul", {
        className: "footer-menu"
      }, _data.companyLinks.map(function (_ref2) {
        var text = _ref2.text,
            link = _ref2.link;
        return _react["default"].createElement("li", {
          key: text
        }, _react["default"].createElement("a", {
          href: link
        }, text));
      }))), _react["default"].createElement("div", {
        className: "col-md-6 col-lg-3 mt-5 mt-md-0"
      }, _react["default"].createElement("h5", {
        className: "mb-3"
      }, "Contact Us"), _data.emails.map(function (_ref3) {
        var text = _ref3.text,
            email = _ref3.email,
            number = _ref3.number;
        return _react["default"].createElement(_react.Fragment, {
          key: text
        }, _react["default"].createElement("div", {
          className: "gray-h6-inside mb-4"
        }, _react["default"].createElement("h6", {
          className: "mb-0",
          style: {
            color: '#fff'
          }
        }, text), _react["default"].createElement("a", {
          href: "mailto:".concat(email)
        }, email), _react["default"].createElement("h6", null, number)));
      }), _data.address.map(function (_ref4) {
        var country = _ref4.country,
            address1 = _ref4.address1,
            address2 = _ref4.address2;
        return _react["default"].createElement(_react.Fragment, {
          key: country
        }, _react["default"].createElement("div", {
          className: "gray-h6-inside mb-3"
        }, _react["default"].createElement("h6", {
          className: "mb-0",
          style: {
            color: '#fff'
          }
        }, _react["default"].createElement("u", null, country)), _react["default"].createElement("h6", {
          className: "mb-0"
        }, address1), _react["default"].createElement("h6", {
          className: "mb-0"
        }, address2)));
      })), _react["default"].createElement("div", {
        className: "col-md-6 col-lg-4 mt-5 mt-md-0"
      }, _react["default"].createElement("h5", {
        className: "mb-3"
      }, "Follow Us"), _react["default"].createElement("div", {
        className: "mb-4"
      }, _data.socialMediaLinks.map(function (_ref5) {
        var link = _ref5.link,
            text = _ref5.text;
        return _react["default"].createElement("a", {
          key: text,
          href: link,
          className: "footer-social",
          target: "_blank",
          rel: "noopener"
        }, _react["default"].createElement("img", {
          src: "".concat(_config["default"].ASSETS_URL, "/").concat(text, ".png"),
          alt: text
        }));
      })), _react["default"].createElement("h5", {
        className: "mb-3"
      }, "Secure Payments By"), _react["default"].createElement("div", {
        className: "footer-payments"
      }, _react["default"].createElement("img", {
        src: "https://s3.amazonaws.com/honeyguide/assets/stripe-powered-white.png",
        alt: ""
      })))), _react["default"].createElement("div", {
        className: "footer-responsive-separator"
      }))), _react["default"].createElement("div", {
        className: "container footer-brand-container"
      }, _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col"
      }, _react["default"].createElement("div", {
        className: "footer-brand"
      }, _react["default"].createElement("img", {
        src: "".concat(_config["default"].ASSETS_URL, "/test/newlogo.png"),
        alt: "logo",
        className: "footer-logo"
      }), _react["default"].createElement("hr", null), "\xA9 2021 HoneyGuide"))))));
    }
  }]);
  return Footer;
}(_react.Component);

exports["default"] = Footer;